/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../customer_form_controller.ts"/>
/// <reference path="../../../services/customer/customer_interfaces.ts"/>
/// <reference path="../../components.ts"/>

namespace DealerwareWebComponents {

    "use strict";

    import IDealerwareCustomerFactory = DealerwareWebServices.IDealerwareCustomerFactory;
    import IDealerwareCustomerFormController = DealerwareWebComponents.IDealerwareCustomerFormController;

    export interface IDriversLicenseFormController extends IDealerwareCustomerFormController {

        // Properties
        //-------------------------------------------

        //
        number: string;
        name: string;
        line1: string;
        line2: string;
        city: string;
        country: string;
        stateLabel: string;
        stateRequired: boolean;
        state: string;
        zip: string;
        verified: boolean;

        // Methods
        //-------------------------------------------

        saveDriversLicense() : void;
        unverifyDriversLicense(oldValue : any, newValue : any) : void;
        toggleBlacklistState() : void;
    }


    export class DriversLicenseFormDirectiveController extends CustomerFormController implements IDriversLicenseFormController{

        public static $inject : string[] = [
            '$timeout',
            '$scope',
            'CurrentUser',
            '$dealerwareCustomerFactory',
            '$mdDialog',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$dealerwareInternationalizationData'];

        // Properties
        //--------------------------------------------------------------
        public canChangeVerifiedState: boolean = true;
        public labels: {
            navItems?: any
        };

        // Accessors
        //---------------------------------------------

        public set number(dlNumber : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.number,dlNumber);
            this.customer.driversLicense.data.number = dlNumber;
        }

        public get number() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.number : '';
        }

        public set name(name : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.name,name);
            this.customer.driversLicense.data.name = name;
        }

        public get name() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.name : '';
        }

        public set line1(line1 : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.line1,line1);
            this.customer.driversLicense.data.line1 = line1;
        }

        public get line1() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.line1 : '';
        }

        public set line2(line2 : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.line2,line2);
            this.customer.driversLicense.data.line2 = line2;
        }

        public get line2() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.line2 : '';
        }

        public set city(city : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.city,city);
            this.customer.driversLicense.data.city = city;
        }

        public get city() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.city : '';
        }

        public set country(country : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.country,country);
            this.customer.driversLicense.data.country = country;
        }

        public get country() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.country : '';
        }

        public get stateLabel() : string {
            if (this.customer.driversLicense) {
                return this.customer.driversLicense.data.country === 'US' ? 'State' :
                       this.customer.driversLicense.data.country === 'CA' ? 'Province' : 'State/Province';
            }

            return 'State/Province';
        }

        public get stateRequired() : boolean {
            return this.country === 'US' || this.country === 'CA';
        }

        public set state(state : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.state,state);
            this.customer.driversLicense.data.state = state;
        }

        public get state() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.state : '';
        }

        public set zip(zip : string) {
            this.unverifyDriversLicense(this.customer.driversLicense.data.zip,zip);
            this.customer.driversLicense.data.zip = zip;
        }

        public get zip() : string {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense) ? this.customer.driversLicense.data.zip : '';
        }

        public get verified() : boolean {
            return (this.customer && angular.isObject(this.customer) && this.customer.hasOwnProperty('driversLicense') && this.customer.driversLicense ) ? this.customer.driversLicense.data.verified : false;
        }

        public set verified(verified : boolean) {
            this.customer.driversLicense.data.verified = verified;
        }

        // Constructor
        //-----------------------------------------------------------
        constructor(public $timeout: any,
                    public $scope: any,
                    public CurrentUser: any,
                    public $dealerwareCustomerFactory: any,
                    public $mdDialog: any,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $dealerwareInternationalizationData: any) {
            super($timeout,$dealerwareCustomerFactory);
            this.getLabels('contracts');
        }

        // Methods
        //---------------------------------------------------------------

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public onCountryChange(country: string) : void {
            if (this.country !== country) {
                this.state = undefined;
            }
        }

        public get zipLabel() : string {
            if (this.customer.driversLicense) {
                return (this.labels && this.labels.navItems) ? this.customer.driversLicense.data.country === 'US' ? this.labels.navItems.driversLicense.us_zip :
                    this.customer.driversLicense.data.country === 'CA' ? this.labels.navItems.driversLicense.ca_zip_1 : this.labels.navItems.driversLicense.ca_zip_2 : 'Zip/Postal Code';
            }

            return 'Zip/Postal Code';
        }

        public saveDriversLicense() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');

            this.customer.driversLicense.$save({
                params: {
                    location_id: this.$mobilityCompanyAuthentication.location.id,
                    customer_id: this.customer.accountSettings.data.id
                },
                promise: true
            }).then(
                function(dl: any) {
                    _self.customer.driversLicense.data.id = dl.data.id;
                    _self.canChangeVerifiedState = true;
                    _self.customer.driversLicense.markAsMaster();
                    _self.$scope.driversLicenseForm.$setPristine();
                    loader.close();
                    _self.$dealerwareNotification.toast('Driver\'s license saved!');
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public unverifyDriversLicense(oldValue : any, newValue : any) : void {
            var _unset = (oldValue && !(oldValue  == newValue)) ? true : false;
            if (_unset) {
                this.verified = false;
                this.canChangeVerifiedState = false;
            }
        }

        public toggleBlacklistState() : void {
            var _self = this;
            var currentCanRent = this.customer.driversLicense.data.can_rent;
            var buttonId = currentCanRent ? '#add_to_dnr' : '#remove_from_dnr';

            this.$mdDialog.show(this.$mdDialog.prompt()
                .title(currentCanRent ? 'Add to DNR' : 'Remove from DNR')
                .placeholder('DNR Reason')
                .ariaLabel('DNR Reason')
                .openFrom(buttonId)
                .closeTo(buttonId)
                .ok('Save')
                .cancel('Cancel')
            ).then(function(reason: any) {
                var toggleBlacklistFn = currentCanRent ? _self.customer.accountSettings.$blacklistCustomer : _self.customer.accountSettings.$unblacklistCustomer;

                var loader = _self.$dealerwareLoading.show('Saving...');
                toggleBlacklistFn({
                    promise: true,
                    params: {
                        location_id: _self.$mobilityCompanyAuthentication.location.id,
                        id: _self.customer.customerId,
                        note_content: reason
                    }
                }).then(
                    function(returnValue: any) {
                        _self.customer.driversLicense.data.can_rent = !currentCanRent;
                        _self.customer.loadNotes().finally(
                            function() {
                                loader.close();
                                _self.$dealerwareNotification.toast('DNR Update Complete!');
                            }
                        );
                    },
                    function(response: any) {
                        loader.close();
                        _self.$dealerwareNotification.apiError(response);
                    }
                );
            });
        }
    }

    getDealerwareWebComponentsModule().controller('DriversLicenseFormDirectiveController', DriversLicenseFormDirectiveController);


    export class DriversLicenseFormDirective implements ng.IDirective {
        public restrict         : string    =   'EA';
        public controller       : any       =   'DriversLicenseFormDirectiveController';
        public controllerAs     : string    =   'driversLicenseController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            onSaveSuccess: '&',
            onSaveError: '&',
            onCancel: '&',
            customer: '=',
            readOnly: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/customer/drivers_license/drivers_license_form_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCustomerDriversLicenseForm",() => new DriversLicenseFormDirective());
}
